import {unstable_batchedUpdates} from 'react-dom';

const headers = new Map();
const pending = new Set();
let observer = null, frame = null, generation = 0;
const schedule = header => {
  if (!headers.has(header)) return;
  pending.add(header);
  if (frame === null) frame = requestAnimationFrame(flush);
};
const scheduleAll = () => headers.forEach((_, header) => schedule(header));

function measure(header) {
  const title = header.querySelector('.title');
  const metadata = header.querySelector('.song-header-metadata');
  const fixed = [...header.querySelectorAll('.song-position, .song-transpose-control, .song-header-actions')]
    .reduce((width, item) => width + item.getBoundingClientRect().width, 0);
  const buttons = [...header.querySelectorAll('.song-title-group button, .position-buttons')]
    .filter(item => !item.classList.contains('title') && (!item.closest('.position-buttons') || item.classList.contains('position-buttons')))
    .reduce((width, item) => width + item.getBoundingClientRect().width, 0);
  const required = (title?.scrollWidth || 0) + (metadata?.scrollWidth || 0) + fixed + buttons + 40 + 6 * header.children.length;
  const notation = header.querySelector('.notation')?.getBoundingClientRect().width || 0;
  const available = header.clientWidth;
  return {notation: required + notation > available, metadata: required > available};
}
function flush() {
  frame = null;
  const batch = [...pending]; pending.clear();
  const updates = [];
  // Complete every geometry read before any React update can change layout.
  for (const header of batch) {
    const subscription = headers.get(header);
    if (!subscription || !header.isConnected) continue;
    const next = measure(header), previous = subscription.previous;
    if (!previous || next.notation !== previous.notation || next.metadata !== previous.metadata) {
      subscription.previous = next;
      updates.push(() => {if (headers.get(header) === subscription) subscription.update(next);});
    }
  }
  unstable_batchedUpdates(() => updates.forEach(update => update()));
}

export function observeSongHeader(header, update) {
  if (!headers.size) {
    const current = ++generation;
    if (typeof ResizeObserver !== 'undefined') {
      observer = new ResizeObserver(entries => entries.forEach(entry => schedule(entry.target)));
    } else window.addEventListener('resize', scheduleAll);
    document.fonts?.addEventListener?.('loadingdone', scheduleAll);
    if (document.fonts?.status !== 'loaded') document.fonts?.ready.then(() => {if (generation === current) scheduleAll();});
  }
  headers.set(header, {update, previous: null});
  observer?.observe(header);
  schedule(header);
  return () => {
    headers.delete(header); pending.delete(header); observer?.unobserve?.(header);
    if (!headers.size) {
      generation++;
      observer?.disconnect(); observer = null;
      window.removeEventListener('resize', scheduleAll);
      document.fonts?.removeEventListener?.('loadingdone', scheduleAll);
      if (frame !== null) cancelAnimationFrame(frame);
      frame = null; pending.clear();
    }
  };
}
